import { useCallback, useEffect, useState } from 'react';
import { calculateHistoryExtent } from '../utils/extentUtils';

export const useVehicleHistoryExtent = (coords, disableExternalExtent) => {
  const [extent, setExtent] = useState(undefined);

  const changeExtent = useCallback((inputCoords) => {
    if (!inputCoords || inputCoords.length === 0) return;

    const newExtent = calculateHistoryExtent(inputCoords);

    if (newExtent) {
      setExtent(newExtent);
    }
  }, []);

  useEffect(() => {
    if (disableExternalExtent) return;
    if (!coords || coords.length === 0) return;

    changeExtent(coords);
  }, [coords, disableExternalExtent, changeExtent]);

  return {
    extent,
    setExtent,
    changeExtent,
  };
};

export default useVehicleHistoryExtent;
